<template>
  <SkeletonLoaderConclusion v-if="isLoadingData" />
  <section v-else class="checkin-conclusion">
    <HeaderMessage
      :badgeMessage="'Confirmação de chegada pendente'"
      :heading="heading"
      icon="AlertCircleSvg"
      ref="headerMessage"
      :showBadge="true"
    >
      <VNavButton
        v-if="showButton"
        ref="buttonUnitArrivalHeader"
        variant="primary"
        text="Confirmar chegada"
        onBrand
        :disabled="!buttonAllowed"
        @click.native="triggerConfirmArriving"
      />
    </HeaderMessage>
    <div v-if="headerMessageStucked && !openDrawer" class="fake-div-top" />
    <InfoTicket
      ref="infoTicket"
      :hasSurvey="showSurvey"
      :unit="currentUnitName"
      :patientName="patientName"
      :scheduleDate="scheduleDate"
      :qrcode="true"
    />
    <DrawerBottom
      :open="openDrawer"
      @toggle="openDrawer = !openDrawer"
      @close="openDrawer = false"
      v-if="openDrawer"
    >
      <template #content>
        <div class="drawer-content">
          <h3>{{ !notArrived ? 'Confirmação de chegada' : 'Quase lá!' }}</h3>

          <p>Atenção! A próxima etapa só deve ser realizada ao chegar no laboratório.</p>

          <div class="drawer-buttons">
            <button v-if="!notArrived" @click="confirmedArrivalFlow">Confirmar chegada</button>
            <button @click="notArrivalYet">
              {{ notArrived ? 'Entendi' : 'Ainda não cheguei' }}
            </button>
          </div>
        </div>
      </template>
    </DrawerBottom>
    <div v-if="headerMessageStucked && !openDrawer" class="fake-div-bottom" />
  </section>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import {
  admissionProcessFinishedMixin,
  getHoursDifferenceMixin,
  unitArrivalMixin,
  dataLayersMixin,
} from '@/utils/mixins';
import VNavButton from '@/components/commons/VNavButton';
import HeaderMessage from './partials/HeaderMessage';
import InfoTicket from './partials/InfoTicket.partial';
import moment from 'moment';
import SkeletonLoaderConclusion from './partials/SkeletonLoaderConclusion.partial.vue';
import DrawerBottom from '@/components/drawerBottom.component.vue';

export default {
  name: 'CheckinConclusionSimple',

  mixins: [
    admissionProcessFinishedMixin,
    getHoursDifferenceMixin,
    unitArrivalMixin,
    dataLayersMixin,
  ],

  components: {
    HeaderMessage,
    VNavButton,
    SkeletonLoaderConclusion,
    InfoTicket,
    DrawerBottom,
  },

  data() {
    return {
      isLoadingData: true,
      minimalMarginTop: 16,
      headerMessageStucked: false,
      patientName: '',
      scheduleDate: '',
      showSurvey: false,
      currentUnitName: '',
      showButton: false,
      buttonAllowed: true,
      addBottomDiv: false,
      openDrawer: false,
      notArrived: false,
    };
  },

  computed: {
    ...mapState({
      currentAdmission: ({ currentAdmission }) => currentAdmission.data,
      mdmData: ({ mdm }) => mdm.data,
      cpfSearched: ({ cpfSearched }) => cpfSearched.data.cpf,
    }),

    ...mapGetters({
      currentUnit: 'selectedUnit',
    }),
    heading() {
      return 'Quando chegar no laboratório, confirme sua chegada aqui.';
    },

    contentBoxMarginTop() {
      return { height: `${this.minimalMarginTop}px` };
    },
  },

  async mounted() {
    this.getUnit();
    await this.handleAllowConfirmArrival();
    this.getPatientName();
    this.isLoadingData = false;

    this.mostCommonPagesAnalytics({
      eventType: 'funnel_step',
      currentStep: 'Finalização',
      message: this.heading,
    });
  },

  methods: {
    ...mapMutations({ enableLoader: 'enableLoader', setAtUnit: 'global/SET_AT_UNIT' }),

    ...mapActions([
      'getMdmPatientById',
      'updateAdmissionStatus',
      'getDataProviderExamsCategories',
      'global/updateFlowSteps',
      'getAdmissionById',
      'global/setButtonConfirmArrival',
      'getAllowConfirmArrival',
    ]),

    triggerConfirmArriving() {
      this.toggleConfirmArrivingModalDisplay(true, false);
      this['global/setButtonConfirmArrival'](true);
    },

    async showSurveyButton() {
      if (this.currentAdmission.medicalOrders) {
        const { exams = [] } = this.currentAdmission.medicalOrders[0];
        const examsCodes = exams.map((exam) => exam.examCode);

        const { content = [] } = await this.getDataProviderExamsCategories({ exams: examsCodes });
        const specialtiesExams = content.map((ct) => ct.speciality.name);
        const specialtiesToShowExams = ['RESSONANCIA', 'TOMOGRAFIA'];

        const filterExamsPerSpecialty = specialtiesExams.filter((specilty) =>
          specialtiesToShowExams.includes(specilty),
        );

        if (filterExamsPerSpecialty.length > 0) {
          this.hasSurvey = true;
        }

        this.hasSurvey = false;
      }

      this.hasSurvey = false;
    },

    async handleAllowConfirmArrival() {
      this.showButton = true;
      this.buttonAllowed = await this.getAllowConfirmArrival();

      const dateFormat =
        this.currentAdmission.source.origin === 'CEV' ? 'DD/MM/YYYY' : 'DD/MM/YYYY - kk:mm';

      this.scheduleDate = moment(this.currentAdmission.admissionDate).format(dateFormat);
    },

    getPatientName() {
      if (this.mdmData) {
        this.patientName = this.mdmData.name;
      }
    },
    getUnit() {
      if (this.currentAdmission.source.origin !== 'CEV') {
        if (this.selectedUnit) {
          this.currentUnitName = this.selectedUnit.nome;
        }
      }
    },
  },
  async created() {
    await this.getMdmPatientById(this.currentAdmission.mdmIdPatient);
    if (this.currentAdmission.status !== 'CHECK_IN_DONE') {
      await this.admissionProcessFinished();
    }
    await this.showSurveyButton();
    this.handleAllowConfirmArrival();
    this.getPatientName();
    if (this.currentAdmission.source.origin !== 'CEV') {
      this.getUnit();
    }
  },
};
</script>

<style lang="scss" scoped>
.checkin-conclusion {
  position: relative;
  background-color: #f5f5f5;
  margin: 0 -16px -16px;
  padding: 16px;

  &__advertisement {
    align-items: center;
    display: flex;
    flex-direction: row;
    background-color: white;
    margin: 16px 0px;
    border-radius: 8px;
    padding: 16px 24px;

    svg {
      width: 32px;
    }

    p {
      padding-left: 10px;
      text-align: start;
      font-size: 14px;
      line-height: 23.8px;
      font-weight: 400;
    }
  }

  &__notice {
    background-color: white;
    margin: 16px 0px;
    border-radius: 8px;
    padding: 16px 24px;
    display: flex;

    svg {
      width: 40px;
      height: 20px;

      path {
        fill: var(--color-primary);
      }
    }

    p {
      padding-left: 10px;
      text-align: start;
      font-size: 13px;
      line-height: 19px;
      font-weight: 700;
    }
  }

  &__content-box {
    background: #fff;
    border-radius: $border-radius;
    padding: $gap-cozy;
    text-align: left;

    &:nth-child(n + 2) {
      margin-top: $gap-default;
    }

    &.is-stuck {
      margin-top: 175px;
    }

    h2 {
      font: {
        size: 18px;
        weight: 700;
      }
      margin-bottom: $gap-default;
    }

    p {
      margin-bottom: $gap-default;
    }
  }
  .fake-div-top {
    opacity: 0;
    height: 280px;
  }

  .fake-div-bottom {
    opacity: 0;
    height: 110px;
  }
  .drawer-content {
    h3 {
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      color: #161616;
      margin-bottom: 24px;
    }
    p {
      font-weight: 400;
      font-size: 16px;
      line-height: 18.75px;
      text-align: center;
      color: var(--color-grey-11);
      margin-bottom: 24px;
    }
    .drawer-buttons {
      display: flex;
      flex-direction: column;

      button {
        border-radius: 8px;
        background-color: var(--color-primary);
        border: 1px solid var(--color-primary);
        color: white;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        padding: 12px 0;
        width: 100%;

        &:nth-child(2) {
          margin-top: 16px;
          border-color: transparent;
          background-color: transparent;
          color: var(--color-primary);
        }
      }
    }
  }
}
</style>

<style lang="scss">
#app.checkin-conclusion-simple {
  height: 100%;
  .container {
    background: #f4f4f4;
    padding: 0 16px;
  }
}
</style>
